import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

/*
Displays the paginator range string without showing "of {total}".
Useful for APIs that don't return the full total results amount in the API response.
NOTE: adding this as a provider in common modules will cause the paginator to behave this way in any
components that import that module, which is probably not desired.
*/
@Injectable()
export class MatPaginatorNoTotalDisplayed extends MatPaginatorIntl {
  getRangeLabel = (page: number, pageSize: number, totalResults: number) => {
    const minPageAmount = page * pageSize + 1;
    let maxPageAmount = (page + 1) * pageSize;
    if (maxPageAmount > totalResults) {
      maxPageAmount = totalResults;
    }
    return `Showing items ${minPageAmount} - ${maxPageAmount}`;
  };
}
